import { callpassApi } from "@/lib/callpassAxios";
import type {
  CallPassApiResponse,
  CallPassAPIInfoDto,
  ReqGetCallPassAPIInfos,
  ReqUpsertCallPassAPIInfo,
} from "../types/callpass.types";

export const getCallPassAPIInfos = async (
  companyGuid: string,
): Promise<CallPassAPIInfoDto[]> => {
  const params: ReqGetCallPassAPIInfos = { CompanyGuid: companyGuid };
  const { data } = await callpassApi.post<
    CallPassApiResponse<CallPassAPIInfoDto[]>
  >("/api/CallPass/GetCallPassAPIInfos", params);
  if (!data.result) throw new Error(data.message);
  return data.data ?? [];
};

export const upsertCallPassAPIInfo = async (
  params: ReqUpsertCallPassAPIInfo,
): Promise<boolean> => {
  const { data } = await callpassApi.post<CallPassApiResponse<boolean>>(
    "/api/CallPass/UpsertCallPassAPIInfo",
    params,
  );
  if (!data.result) throw new Error(data.message);
  return data.data ?? true;
};
